import { Base_Url } from '../BaseUrl/BaseUrl';

const key = 'seekjobs_events_login';
const validHandle = value => typeof value === 'string' && /^[A-Za-z0-9_-]{32,256}$/.test(value);
export const clearEventsLogin = () => {
  try { sessionStorage.removeItem(key); } catch { /* Storage may be disabled. Never break normal login. */ }
};
export function getEventsLogin() {
  try {
    const record = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (!record || !validHandle(record.handle) || record.api !== Base_Url ||
        !Number.isFinite(record.expires) || record.expires <= Date.now()) {
      clearEventsLogin(); return null;
    }
    return record.handle;
  } catch { clearEventsLogin(); return null; }
}
export function captureEventsLogin() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('events_sso')) return getEventsLogin();
  const values = url.searchParams.getAll('events_sso');
  const old = getEventsLogin();
  if (values.length !== 1 || !validHandle(values[0])) clearEventsLogin();
  else if (old !== values[0]) {
    try {
      sessionStorage.setItem(key, JSON.stringify({
        handle: values[0], api: Base_Url, expires: Date.now() + 600000,
      }));
    } catch { clearEventsLogin(); }
  }
  url.searchParams.delete('events_sso');
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  return getEventsLogin();
}
export function getEventsResumeUrl() {
  const handle = getEventsLogin();
  if (!handle) return null;
  const api = new URL(Base_Url);
  const local = ['localhost', '127.0.0.1'].includes(api.hostname);
  if (api.username || api.password || api.search || api.hash ||
      (api.protocol !== 'https:' && !(local && api.protocol === 'http:'))) throw new Error('Events login is unavailable.');
  api.pathname = api.pathname.replace(/\/$/, '') + '/events/sso/resume';
  api.searchParams.set('request', handle);
  return api.toString();
}
export function resumeEventsLogin() {
  const url = getEventsResumeUrl();
  if (!url) return false;
  clearEventsLogin();
  window.location.replace(url);
  return true;
}
